import React, { createContext, useContext, useState, useCallback, useEffect } from 'react'
import { Toast } from '../components/Toast'
import { setToastHandler } from '../lib/toastStore'

const ToastContext = createContext(null)

export function useToast() {
  const ctx = useContext(ToastContext)
  if (!ctx) return { addToast: () => {}, showToast: () => {}, removeToast: () => {} }
  return ctx
}

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([])

  const addToast = useCallback((message, type = 'success') => {
    const id = Date.now() + Math.random()
    setToasts((prev) => [...prev, { id, message, type }])
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id))
    }, 3000)
    return id
  }, [])

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id))
  }, [])

  // showToast — алиас для addToast (единый API)
  const showToast = addToast

  useEffect(() => {
    setToastHandler(addToast)
    return () => setToastHandler(null)
  }, [addToast])

  return (
    <ToastContext.Provider value={{ addToast, showToast, removeToast }}>
      {children}
      <div className="toast-container" aria-live="polite" aria-label="Уведомления">
        {toasts.map((t) => (
          <Toast key={t.id} id={t.id} message={t.message} type={t.type} />
        ))}
      </div>
    </ToastContext.Provider>
  )
}

/** Безопасный хук — возвращает addToast или no-op, если вне провайдера */
export function useToastOptional() {
  const ctx = useContext(ToastContext)
  return ctx?.addToast ? ctx.addToast : () => {}
}
